import { useSyncExternalStore } from 'react';

/** Resolves the operator's `Pedestal.lobby` knob, `hidden` when unset (index.css). */
const PEDESTAL_SWITCH = '--ui-pedestal-lobby';
const SHOWN = 'shown';

// The Design Constructor writes its knobs as inline styles on <html>; a
// preview toggle re-renders the lobby without a reload.
function subscribe(onChange: () => void): () => void {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
  return () => observer.disconnect();
}

function isPedestalShown(): boolean {
  return getComputedStyle(document.documentElement).getPropertyValue(PEDESTAL_SWITCH).trim() === SHOWN;
}

/** True when the operator turned the lobby pedestal on in the Design Constructor. */
export function useLobbyPedestal(): boolean {
  return useSyncExternalStore(subscribe, isPedestalShown, () => false);
}
